<div [ngClass]="{ negative: value < 0 }">
  <span
    [tooltipStyleClass]="value < 0 ? 'negative' : ''"
    [appTooltip]="value | money: 'positiveComa'"
    tooltipPosition="bottom"
  >
    {{ value | money: 'shortSignSimpleSpace' }}
  </span>
</div>
